import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { Auth } from '../../providers/auth';
import { LoadingController } from 'ionic-angular';
import { HomePage } from '../home/home'; 
import { AboutPage } from '../about/about'; 
import { LoginPage } from '../login/login'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';

@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class ProfilePage {
  username: string;
  password: string;
  email: string;
  fullname:string;
  sex:string;
  education:string;
  birthDate: string;

  errorMessage: string;
  loader:any;
  iagree: boolean;

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public translate: TranslateService, public userdataModel:UserdataModel, public navCtrl: NavController, public auth: Auth, public loadingCtrl: LoadingController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    
    this.username="";
    this.password="";
    this.email="";
    this.fullname="";
    this.sex="";
    this.education="";
    this.birthDate="";

    this.errorMessage="";
    this.iagree=false;
  }
  
  ionViewWillEnter(){
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);
    var username=this.userdataModel.getUsername();
    var email=this.userdataModel.getEmail();
    var password=this.userdataModel.getPassword();
    var fullname=this.userdataModel.getFullname();
    var sex=this.userdataModel.getSex();
    var education=this.userdataModel.getEducation();
    var birthDate=this.userdataModel.getBirthDate();

    if(username){ this.username=username; }
    if(email){ this.email=email; }
    if(password){ this.password=password; }
    if(fullname){ this.fullname=fullname; }
    if(sex){ this.sex=sex; }
    if(education){ this.education=education; }
    if(birthDate){ this.birthDate=this.functions.convertStringDateForViz(birthDate); }
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  goToLogin(){
    this.navCtrl.push(HomePage, {});
  }

  goToDisclaimer(){
    this.navCtrl.push(AboutPage, {});
  }

  editProfile(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();
        this.auth.editProfile(this.username,this.password,this.email,this.fullname,this.sex,this.birthDate,this.education).then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('EditProfileIsOk')!=-1){
            //this.navCtrl.push(HomePage, {});
           }else{
             this.errorMessage=this.auth.errorMessage;
             this.loader.dismiss();
             return;
          }
        });
    }else{
      this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
    }
  }

  logoutCurrentProfile(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();
        this.auth.logout().then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('LogoutIsOk')!=-1){
            this.loader.dismiss();
            this.navCtrl.setRoot(LoginPage, {});
           }else{
             this.errorMessage=this.auth.errorMessage;
             this.loader.dismiss();
             return;
          }
        });
    }else{
      this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
    }
  }
    
  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  presentLoading() {
    this.translate.get('loading').subscribe(value => { 
      this.loader = this.loadingCtrl.create({
        content: value
      });
      this.loader.present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts